import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { Base2Service } from '../base2.service';
import { ToolsService } from '../../tools/tools.service';
import {PanierService} from "../../manage/panier/panier.service";


@Injectable({
  providedIn: 'root'
})

export class Touchterminalpayment {

  constructor(
    private baseClient: BaseclientService,
    private base2: Base2Service,
    private tools: ToolsService
  ) { }



  /*******************
     * ID_WEBSHOP
     *******************/


  /**
    * @description set payintent by id_webshop
    * @param data
    */

  setTouchTerminalPayIntent(data: any): Observable<any> {

    const params = {
      id_webshop: data.id_webshop,
      amount: data.amount,
      id_device: data.id_device,
      id_data: data.order_id ? data.order_id : null,

      print_type: data.print_type ? data.print_type : 0,
    };



    return from(this.baseClient.postBaseApi("payment_touch_terminal", params)).pipe(
      map(data => {
        return data;
      })
    )
  }



  /**
    * @description get payintent state by id_webshop
    * @param data
    */

  getTouchTerminalPayIntent(data: any): Observable<any> {

    const params = {
      id_webshop: data.id_webshop,
      pay_intent_id: data.pay_intent_id,
    };

    return from(this.baseClient.postBaseApi("getPayment_touch_terminal", params)).pipe(
      map(data => {
        return data;
      })
    )
  }



  /**
  * @description set PaymentSucceeded by id_webshop
  * @param data
  * @param pay_intent
  */
  TouchTerminalPaymentSucceeded(data: any, pay_intent: any, credit_fid?: any): Promise<any> {

    const params = {
      id_webshop: data.webshop_id,
      pay_intent_id: pay_intent.id,
      order_id: data.order_id,
      order_payment_id:data.order_payment_id,
      status: pay_intent.status,
      jsonBorne: { "pay_intent": pay_intent },
      fidelityDiscountUsed: credit_fid && this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null,
      basket: this.tools.getStor(PanierService.TAG_STORAGE)
    };

    return this.baseClient.postBase("paymentSucceeded_touch_terminal", params);
  }



  /**
   * @description getAccesTouchTerminal
   * @param data
     */
  getAccesTouchTerminal(data: any, borne?: any): Promise<any> {

    const params = {
      id_webshop: data.id_webshop,
      code: data.code,
      borne: borne
    };

    return this.baseClient.postBase("get_acces_touch_terminal", params);
  }










  /*******************
    * MERCHANT
    *******************/


  /**
    * @description set payintent by mechant recharge
    */

  setTouchTerminalPayIntentMerchant(amount: any, id_device: any): Promise<any> {

    const params = {
      "amount": amount,
      "id_device": id_device
    };

    return new Promise(resolve => {
      this.base2.postBase("points_of_sale", params).then(data => {

        resolve(data);

      });
    });

  }
















}
